// src/merch/liveTexture.js
//
// Live 3D preview while a layer is being dragged / scaled / rotated.
// The flat editor already draws the moving layer on top of a pre-built
// "everything else" canvas; it also paints that into one shared 1024²
// canvas and publishes it here. The 3D print meshes listen and upload it
// straight to their texture — no React re-renders, no re-compositing.
// When the drag ends the live canvas stays on screen until the real
// composite arrives (they're pixel-identical), so nothing flickers.

import { useEffect } from "react";

const subs = new Set();
let live = null; // { zone, canvas }

export const LIVE_SIZE = 1024;
let shared = null;
export function liveCanvas() {
  if (!shared) {
    shared = document.createElement("canvas");
    shared.width = shared.height = LIVE_SIZE;
  }
  return shared;
}

export function publishLive(zone, canvas) {
  live = { zone, canvas };
  subs.forEach((f) => f(live));
}

/** Point a three.js texture at the live canvas whenever `zoneId` is live. */
export function useLiveTexture(zoneId, tex) {
  useEffect(() => {
    const f = (l) => {
      if (l.zone !== zoneId) return;
      tex.image = l.canvas;
      tex.needsUpdate = true;
    };
    subs.add(f);
    return () => subs.delete(f);
  }, [zoneId, tex]);
}
